// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"emailConfirmationAlert__gradient-bg5__bTez7","confirmation":"emailConfirmationAlert__confirmation__CPBJD","successAlert":"emailConfirmationAlert__successAlert__JNOjJ"};